import { ConnectionHandler } from 'relay-runtime';
export default function rangeDeleteUpdater(store, {
  parentId,
  connectionKey,
  connectionFilters,
  deletedId
}) {
  const connection = ConnectionHandler.getConnection(store.get(parentId), connectionKey, connectionFilters);

  if (!connection) {
    return;
  }

  ConnectionHandler.deleteNode(connection, deletedId);
}